/*Moving to '@tw/shared-ui-components/lib/common/helper'
  -- to remove later
*/

import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import numeral from "numeral";
import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import { LeftNavMapping } from "../utils/constants"

import DeliveryCycleInfo from "@tw/shared-ui-components/lib/components/variantDrawerDeliveryCycleInfo/variantDrawerDeliveryCycleInfo";

export const getPdmApiUrl = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .PDM_BFF_API || "http://localhost:3002";

export const getPurchaseUrl = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .PURCHASE_BFF_API || "http://localhost:3002";

export const getAcApiUrl = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .CI_BFF_API || "http://localhost:3003";

export const getUserLandingPage = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LOGIN_LANDING_PAGE || "/profile";

export const getRouter = () => {
  if (typeof window === "undefined") return {};
  return window.useRouter && window.useRouter();
};

export const getParams = () => {
  if (typeof window === "undefined") return {};
  return window.useParams && window.useParams();
};
const deliveryDescriptionArray = [
  "單月配送意指以一個月為配送週期，配送當月份量之產品",
  "雙月配送意指以兩個月為配送週期，配送兩個月之份量產品",
];

const enumeration = {
  1: ['', '單月配送意指以一個月為配送週期，配送當月份量之產品'],
  2: ['', '隔月配送意指以兩個月為配送週期，配送一個月份量之產品', '雙月配送意指以兩個月為配送週期，配送兩個月之份量產品']
}
const bindFilterateProduct = (product) => {
  if (!product) return deliveryDescriptionArray
  const { sop_delivery_frequency_period, sop_frequency_switch } = product?.info;
  if (sop_delivery_frequency_period && sop_delivery_frequency_period?.value && sop_frequency_switch && (sop_frequency_switch?.value == "Open" || sop_frequency_switch?.value == "open")) {
    const deliveryFrequencyPeriod = JSON.parse(sop_delivery_frequency_period?.value);
    let deliveryIntroductionArray = []
    for (let index in deliveryFrequencyPeriod) {
      deliveryFrequencyPeriod[index].map((item) => {
        deliveryIntroductionArray.push(enumeration[index][item.period])
      })
    }
    return deliveryIntroductionArray
  } else {
    return deliveryDescriptionArray
  }
}
export const renderDeliveryInfo = (product) => (
  <DeliveryCycleInfo deliveryDescriptionArray={bindFilterateProduct(product)} />
);

export const useParamas = () => {
  const [params, setParams] = useState({});
  if (typeof window === "undefined") return {};
  const routeParams = (window.useParams && window.useParams()) || {};
  const { search } = (window.useLocation && window.useLocation()) || {};
  useEffect(() => {
    setParams({
      ...routeParams,
      ...getQueryStringParams(search),
    });
  }, [routeParams, search]);
  return { params };
};

//-----------------------
const getQueryStringParams = (query) => {
  if (!query) return {};
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
      .split("&")
      .reduce((params, param) => {
        let [key, value] = param.split("=");
        params[key] = value
          ? decodeURIComponent(value.replace(/\+/g, " "))
          : "";
        return params;
      }, {})
    : {};
};
export const getLoggedInUserInfo = () => {
  if (typeof window === "undefined") return {};

  const cookie = new Cookies();

  const role = cookie.get("role") || "Guest";
  const vAda = cookie.get("vAda");
  const loginAda = cookie.get("ada") || "";
  const accessToken = cookie.get("accessToken") || "";
  const loginType = cookie.get("loginType") || "";

  return { role, loginAda, accessToken, loginType, vAda };
};
export const formatAmount = (value = null, currency = "$") => {
  const formattedAmount = numeral(value).format("0,0");

  return `${currency} ${formattedAmount}`;
};
export const formatNumber = (value = null) => {
  const formattedNumber = numeral(value).format("0,0");

  return `${formattedNumber}`;
};

const productStatusObj = {
  buyAhead: {
    label: "預售",
    colorCode: "#D91734",
    actionType: "AddToCart",
    isActionEnabled: true,
  },
  upcoming: {
    label: "尚未上市",
    colorCode: "#D91734",
    actionType: "AddToCart",
    isActionEnabled: false,
  },
  outOfStock: {
    label: "暫停供貨",
    colorCode: "#D91734",
    // actionType: "NotifyMe",
    // isActionEnabled: true,
    actionType: "AddToCart",
    isActionEnabled: false,
  },
  notForSale: {
    label: "暫停供貨",
    colorCode: "#D91734",
    // actionType: "NotifyMe",
    // isActionEnabled: true,
    actionType: "AddToCart",
    isActionEnabled: false,
  },
};

export const getProductStatus = (status) => {
  const productStatus = status?.toLowerCase();
  if (productStatus === "buyahead") {
    return productStatusObj.buyAhead;
  } else if (productStatus === "upcoming") {
    return productStatusObj.upcoming;
  } else if (productStatus === "outofstock") {
    return productStatusObj.outOfStock;
  } else if (productStatus === "notforsale") {
    return productStatusObj.notForSale;
  }
};

export const addToCart = async (
  itemCode,
  quantity = 1,
  additionalData = {}
) => {
  const apiUrl = getPdmApiUrl();

  const getConsigneeData = () => {
    if (typeof window === "undefined") return {};
    const onBehalfData = JSON.parse(localStorage.getItem("onbehalf"));

    if (!onBehalfData) return {};
    return {
      consigneeAda: onBehalfData.ada,
      consigneeType: onBehalfData.loginType,
      consigneeMemberType: onBehalfData.loginMemberType,
    };
  };

  const res = await axios.post(
    `/add-to-cart`,
    {
      itemCode,
      quantity: quantity,
      ...additionalData,
      ...getConsigneeData(),
    },
    {
      baseURL: apiUrl,
    }
  );
  return res;
};

export const handleCancelBtn = (input, fn) => {
  if (input?.value.trim().length > 0) {
    fn({ display: "block" });
  } else if (!input?.value.trim().length) {
    fn({ display: "none" });
  }
};

export const getVisitorStatus = () => {
  const cookie = new Cookies();
  if (cookie.get("vAda") && !cookie.get("ada")) {
    return true;
  } else {
    return false;
  }
};

export const getLeftNavMapping = (route) => {
  LeftNavMapping.forEach(function (map) {
    map.subURL.forEach(function (url) {
      if (url.toLowerCase() === route.split('?')[0].toLowerCase()) {
        route = map.URL.includes("?") ? map.URL.split('?')[0] : map.URL;
      }
    })
  });

  return route;
};